import { disabledColor } from '@zego/theme';

import generateTintTheme from './generateTintTheme';

export default generateTintTheme(disabledColor(2));
